module.exports = "/cyber/_next/static/images/top20Slide-eaf13b8867a6a436f0e4c42a5f28cf4a.jpg";